import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import s from "./WelcomePage.module.css";

export default function WelcomePage({ onContinue }) {
  const [show, setShow] = useState(false);
  const [animData, setAnimData] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    fetch("/cheers.json")
      .then((r) => r.json())
      .then(setAnimData)
      .catch(() => {});
  }, []);

  return (
    <div className={s.page}>
      <div className={`${s.card} ${show ? s.cardVisible : ""}`}>
        {/* Cheers animation */}
        <div className={s.lottieWrap}>
          {animData && (
            <Lottie animationData={animData} loop className={s.lottie} />
          )}
        </div>

        <h1 className={s.title}>Congratulations!</h1>
        <p className={s.subtitle}>
          Your account is ready. You've just taken the first step
          toward mastering Swedish.
        </p>

        <button className={s.ctaBtn} onClick={onContinue}>
          Go to Dashboard
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}
